/**
 * Search-offer "ערוך חיפוש" handshake.
 *
 * First search: editor is closed, so loading can mount SearchResults (skeleton).
 * Hotels/packages may still use SearchLoadingModal; flights leave the atmosphere
 * landing immediately and show the results-page skeleton instead.
 *
 * Edit search used to keep the editor open after submit. That forced
 * isAtmosphereLanding + hideResults, so SearchResults stayed unmounted and the
 * UI never left the form + "טוענים תוצאות" modal.
 *
 * While a search is in flight the editor is treated as inactive so the compact
 * bar + skeleton can show immediately; persist-close then keeps it closed after
 * loading ends.
 */

export function resolveSearchOfferEditorHandshake({
  isSearchEditorOpen = false,
  loading = false,
} = {}) {
  const editorOpen = Boolean(isSearchEditorOpen);
  const isLoading = Boolean(loading);
  return {
    editorActive: editorOpen && !isLoading,
    shouldPersistCloseEditor: editorOpen && isLoading,
  };
}

export function shouldShowSearchOfferAtmosphereLanding({
  isDashboardSearchOfferPath = false,
  hideOuterFlightSearchForFlightFlow = false,
  editorActive = false,
  searchBarCollapsedLayout = false,
  showFlightBookingFlowMockup = false,
  loading = false,
  isSearched = false,
} = {}) {
  if (!isDashboardSearchOfferPath || hideOuterFlightSearchForFlightFlow) {
    return false;
  }
  if (editorActive) return true;
  if (searchBarCollapsedLayout) return false;
  if (showFlightBookingFlowMockup && loading) return false;
  return Boolean(showFlightBookingFlowMockup || (!loading && !isSearched));
}

export function shouldHideSearchOfferResults({
  isAtmosphereLanding = false,
  editorActive = false,
} = {}) {
  return Boolean(isAtmosphereLanding || editorActive);
}

/**
 * Opens the existing search-offer "חיפוש חדש" editor.
 * Does not create or reset SearchContext.
 */
let pendingMainFlightSearchEditor = false;

export function requestMainFlightSearchEditor() {
  pendingMainFlightSearchEditor = true;
}

export function peekMainFlightSearchEditorRequest() {
  return pendingMainFlightSearchEditor;
}

export function takeMainFlightSearchEditorRequest() {
  const pending = pendingMainFlightSearchEditor;
  pendingMainFlightSearchEditor = false;
  return pending;
}
